import {
  Box,
  CardActionArea,
  Paper
} from '@mui/material';

import { NextLinkComposed } from '../components/Link';


const CompactRequestCard = ({ job }) => {

  return (
    <CardActionArea
      sx={{ mb: 2 }}
      component={NextLinkComposed}
      to={{ pathname: `/quotes-requested${job.detail_path}` }}
    >
      <Box
        component={Paper}
        sx={{
          p: 2,
          bgcolor: 'white',
          fontFamily: 'fontFamily',
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box flexGrow={1}>
            <Box fontWeight="fontWeightBold" fontSize={14} component="h5" my={1}>
              {job.car_string}
            </Box>
            <Box fontWeight="fontWeightLight" fontSize={16} component="h6" my={0}>
              {job.name}
              </Box>
            <Box component="p" color="primary.light" my={1} fontSize={14}>
              Based on <Box component="span" fontSize={16} fontWeight="fontWeightBold">{job.estimate_count}</Box> {job.estimate_count == 1 ? `Quote` : `Quotes`}
            </Box>
          </Box>

          <Box
            flexDirection="column"
            justifyContent="center"
            p={2}
            width={100}
            color="primary.light"
          >
            <Box
              pb={0.25}
              textAlign="end"
              fontSize="21px"
              fontWeight={500}>R{job.avg_estimate}</Box>
            <Box textAlign="end">Average</Box>
          </Box>
        </Box>
      </Box>
    </CardActionArea>
  )
}

export default CompactRequestCard;
